import { getQaSelector } from '../../../../utils/common'
import { Link } from '../../../Link'
import Text from '../../../Text'

import { QA_NAME_CALENDAR_GRID_CARD_TITLE } from './CalendarGridCardTitle.constants'

import * as styles from './CalendarGridCardTitle.module.css'

function CalendarGridCardTitle({ title, titleUrl }) {
  return titleUrl ? (
    <Link
      {...getQaSelector({ value: QA_NAME_CALENDAR_GRID_CARD_TITLE })}
      className={styles.CalendarGridCardTitle}
      to={titleUrl}
    >
      {title}
    </Link>
  ) : (
    <Text className={styles.CalendarGridCardTitle}>{title}</Text>
  )
}

export default CalendarGridCardTitle
